'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupUpsellModalContent = undefined;

var _Modal = require('scripts/components/Modal');

var _Helpers = require('scripts/components/Helpers');

var _Upsell = require('scripts/components/Upsell');

var dom = {
  overlay: '[data-overlay]',
  addToCart: '[add-to-cart]',
  pdpAtc: '[pdp-atc]',
  upsellAtc: '[data-is-upsell-atc]',
  upsellModalContainer: '[data-modal="subscription-upsell"]',
  subscriptionModalContents: '[modal-content="subscription-upsell"]',
  upsellLink: '[upsell-link]'
};

var setupUpsellModalContent = exports.setupUpsellModalContent = function setupUpsellModalContent(handle) {
  var resource = 'products/' + handle;
  var templateName = 'subscription-upsell';
  var qty = $(dom.pdpAtc).attr('data-qty') || 1;
  var variantId = $(dom.pdpAtc).attr('data-variant-id');
  (0, _Helpers.getAlternativeTemplate)(resource, templateName).then(function (response) {
    $(dom.subscriptionModalContents).html(response);
    (0, _Modal.show)('subscription-upsell');
    $(dom.overlay).addClass('is-no-click overlay--upsell-dark');
    var $upsellModalContainer = $(dom.upsellModalContainer);
    $upsellModalContainer.find(dom.upsellAtc).attr('data-qty', qty).trigger('focus');

    $upsellModalContainer.find('.modal__close').attr('data-toggle-inline-cart', true);
    $upsellModalContainer.find(dom.upsellLink).attr('data-toggle-inline-cart', true);

    var isSubscription = true;
    (0, _Upsell.trackUpsellShown)(handle, isSubscription);
  });
};